import { notifications } from '@mantine/notifications'

type TResult = {
  notifySuccess: (message: string) => void
  notifyError: (message: string) => void
  notifyInfo: (message: string) => void
  notifyWarning: (message: string) => void
}

export const useNotifications = (): TResult => {
  const notifySuccess = (message: string, title?: string) => {
    notifications.show({
      title,
      message,
      color: 'green',
    })
  }

  const notifyError = (message: string, title?: string) => {
    notifications.show({
      title,
      message,
      color: 'red',
    })
  }

  const notifyInfo = (message: string, title?: string) => {
    notifications.show({
      title,
      message,
      color: 'blue',
    })
  }

  const notifyWarning = (message: string, title?: string) => {
    notifications.show({
      title,
      message,
      color: 'yellow',
    })
  }

  return { notifySuccess, notifyError, notifyInfo, notifyWarning }
}
